module.exports = "<div class=\"live-info\">LIVE</div>\n<button class=\"live-button\">BACK TO LIVE</button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/dvr_controls/public/index.html
 ** module id = 143
 ** module chunks = 0
 **/